import { render, staticRenderFns } from "./ToolsPanel.vue?vue&type=template&id=5dd83d8f&scoped=true"
import script from "./ToolsPanel.vue?vue&type=script&lang=js"
export * from "./ToolsPanel.vue?vue&type=script&lang=js"
import style0 from "./ToolsPanel.vue?vue&type=style&index=0&id=5dd83d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd83d8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
